import { useState } from "react";
import { Navigate, NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  LayoutDashboard,
  Package,
  Sparkles,
  BookOpen,
  Image as ImageIcon,
  MessageSquareQuote,
  MapPin,
  Newspaper,
  Settings as SettingsIcon,
  ClipboardList,
  LogOut,
  Menu,
  X,
  ExternalLink,
} from "lucide-react";

const NAV = [
  { to: "/admin", label: "Ringkasan", icon: LayoutDashboard, end: true },
  { to: "/admin/pesanan", label: "Pesanan", icon: ClipboardList },
  { to: "/admin/produk", label: "Produk", icon: Package },
  { to: "/admin/manfaat", label: "Manfaat", icon: Sparkles },
  { to: "/admin/tentang", label: "Tentang Kami", icon: BookOpen },
  { to: "/admin/galeri", label: "Galeri", icon: ImageIcon },
  { to: "/admin/testimoni", label: "Testimoni", icon: MessageSquareQuote },
  { to: "/admin/lokasi-mitra", label: "Lokasi & Mitra", icon: MapPin },
  { to: "/admin/artikel", label: "Artikel", icon: Newspaper },
  { to: "/admin/pengaturan", label: "Pengaturan Brand", icon: SettingsIcon },
];

export const AdminLayout = () => {
  const { isAuthenticated, username, logout } = useAuth();
  const [open, setOpen] = useState(false);

  if (!isAuthenticated) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-cream-200 flex">
      {/* Sidebar */}
      <aside
        className={`fixed md:static inset-y-0 left-0 z-40 w-64 shrink-0 bg-ink text-cream flex flex-col transition-transform duration-300 ${
          open ? "translate-x-0" : "-translate-x-full md:translate-x-0"
        }`}
      >
        <div className="px-6 py-6 border-b border-cream/10">
          <div className="flex items-center gap-2">
            <span className="inline-block h-2.5 w-2.5 rounded-full bg-honey" />
            <span className="font-display text-xl">Samsi Madu</span>
          </div>
          <span className="text-xs text-cream/50">Panel Admin</span>
        </div>

        <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors duration-200 ${
                  isActive ? "bg-honey text-cream" : "text-cream/70 hover:bg-cream/10 hover:text-cream"
                }`
              }
            >
              <item.icon size={18} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-4 border-t border-cream/10 space-y-1">
          <Link
            to="/"
            target="_blank"
            className="flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-cream/70 hover:bg-cream/10 hover:text-cream transition-colors duration-200"
          >
            <ExternalLink size={18} />
            Lihat Situs
          </Link>
          <button
            onClick={logout}
            data-testid="admin-logout-btn"
            className="w-full flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-cream/70 hover:bg-cream/10 hover:text-cream transition-colors duration-200"
          >
            <LogOut size={18} />
            Keluar ({username})
          </button>
        </div>
      </aside>

      {open && (
        <div
          className="fixed inset-0 z-30 bg-black/40 md:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Content */}
      <div className="flex-1 min-w-0">
        <header className="md:hidden flex items-center justify-between px-4 py-3 bg-ink text-cream sticky top-0 z-20">
          <span className="font-display text-lg">Samsi Madu Admin</span>
          <button onClick={() => setOpen((v) => !v)}>{open ? <X size={22} /> : <Menu size={22} />}</button>
        </header>
        <main className="p-6 md:p-10 max-w-6xl mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
